export class SocialProfile {
    platform = '';
    url = '';

    constructor(profile = null) {
        if (profile) {
            this.platform = profile.socialPlatform || this.platform;
            this.url = profile.url || this.url;
        }
    }

}
